module.exports = __webpack_public_path__ + "static/media/Marilyn Mages Headshot.01349be2.jpeg";